module.exports = __webpack_public_path__ + "static/media/tro.405b6ea1.mp3";